import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../../../../error/error-handling/product-management-error';
import {CatalogSummary, Product} from '../../../../../models/clare';
import {ProductFormData} from '../create-product.types';

export const CreateProductActions = createActionGroup({
  source: 'Create Product',
  events: {
    'Load Catalogs': emptyProps(),
    'Load Catalogs Success': props<{catalogs: CatalogSummary[]}>(),
    'Load Catalogs Failure': emptyProps(),
    'Create Product': props<{data: ProductFormData; requestId: string}>(),
    'Create Product Success': props<{product: Product; requestId: string}>(),
    'Create Product Failure': props<{error: ProductManagementErrorInterface; requestId: string}>(),
    'Abandon Create Product Request': props<{requestId: string}>(),
    'Create Another Product': props<{addAnotherProduct: boolean}>(),
  },
});
